import { SharedAngular } from '../../@types/sharedAngular';
import angular, { IScope, ITimeoutService } from 'angular';
import { IFieldControllerField } from './field-controller';
import { Guid } from '@Shared.Angular/@types/guid';
import IProcedureActionDetail from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureActionDetail';

angular.module('fg').directive('fgFieldProcedure', [
  function () {
    return {
      replace: true,
      templateUrl: 'angular-form-gen/field-templates/default/procedure.ng.html',
      scope: true,
      controllerAs: 'ctrl',
      controller: [
        '$state',
        '$scope',
        '$timeout',
        'procedureApiService',
        'fileService',
        function (
          $state,
          $scope: IScope,
          $timeout: ITimeoutService,
          procedureApiService: SharedAngular.ProcedureApiService,
          fileService: SharedAngular.FileService
        ) {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const ctrl = this;

          ctrl.field = null;
          ctrl.form = null;
          ctrl.loading = true;
          ctrl.loadingProcedureFailed = false;
          ctrl.files = {};

          let hoverTimeout: angular.IPromise<void>;
          const filePromises = {};

          ctrl.init = function (field: IFieldControllerField, form) {
            ctrl.field = field;
            ctrl.form = form;

            $scope.$watch(() => {
              return field.schema.value;
            }, loadNewProcedure);
            if (field.schema.value) {
              loadProcedure(field.schema.value as Guid);
            } else {
              ctrl.loading = false;
            }
          };

          function loadProcedure(id: Guid) {
            const recordProcedureView = [
              'app.publicmap',
              'app.public-form',
              'app.runner.processmapviewv2',
              'app.runner.flow'
            ].some((x) => x === $state.current.name);
            procedureApiService
              .getProcedure(id, recordProcedureView)
              .then((procedure) => {
                ctrl.procedure = procedure;
                ctrl.loadingProcedureFailed = !procedure;
                ctrl.loading = false;
              })
              .catch(() => (ctrl.loadingProcedureFailed = true));
          }

          function loadNewProcedure(newValue?: Guid, oldValue?: Guid) {
            if (newValue && newValue !== oldValue) {
              loadProcedure(newValue);
            }
          }

          ctrl.toggleMinimized = function (
            $event: MouseEvent,
            action: IProcedureActionDetail
          ) {
            ctrl.loadActionImage(action);
            const element = $event.currentTarget as HTMLElement;
            if (element.classList.contains('minimized')) {
              element.classList.remove('minimized');
            } else {
              element.classList.add('minimized');
            }
          };

          ctrl.startHover = (action: IProcedureActionDetail) => {
            hoverTimeout = $timeout(() => {
              ctrl.loadActionImage(action);
            }, 300);
          };

          ctrl.cancelHover = () => {
            if (hoverTimeout) {
              $timeout.cancel(hoverTimeout);
            }
          };

          ctrl.loadActionImage = (action: IProcedureActionDetail) => {
            if (ctrl.files[action.id] || filePromises[action.id]) {
              return;
            }
            filePromises[action.id] = fileService
              .getFileById(action.modifiedFileId || action.originalFileId)
              .then((response) => {
                if (!response || !response.data) {
                  filePromises[action.id] = null;
                  return;
                }
                ctrl.files[
                  action.id
                ] = `data:${response.data.mimeType};base64,${response.data.data}`;
              })
              .catch(() => (filePromises[action.id] = null));
          };

          ctrl.setTargetImage = function ($event: MouseEvent, image: string) {
            $event.stopPropagation();
            ctrl.targetImage = image;
          };

          ctrl.removeTargetImage = function ($event: MouseEvent) {
            $event.stopPropagation();
            ctrl.targetImage = null;
          };
        }
      ]
    };
  }
]);
